import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import RotaProtegida from './components/auth/RotaProtegida';
import LayoutPublico from './components/layout/LayoutPublico';
import LayoutAdmin from './components/layout/LayoutAdmin';

import HomePage from './pages/public/HomePage';
import SobrePage from './pages/public/SobrePage';
import TransparenciaPage from './pages/public/TransparenciaPage';
import EventosPage from './pages/public/EventosPage';
import FestejoPage from './pages/public/FestejoPage';
import GaleriaPage from './pages/public/GaleriaPage';

import LoginPage from './pages/admin/LoginPage';
import DashboardPage from './pages/admin/DashboardPage';
import AdminDocumentosPage from './pages/admin/AdminDocumentosPage';
import AdminGaleriaPage from './pages/admin/AdminGaleriaPage';
import { AdminEventosPage, AdminFestejoPage, AdminConfiguracoesPage } from './pages/admin/AdminOutrasPaginas';

import './components/ui/ui.css';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<LayoutPublico />}>
            <Route path="/"              element={<HomePage />} />
            <Route path="/sobre"         element={<SobrePage />} />
            <Route path="/transparencia" element={<TransparenciaPage />} />
            <Route path="/eventos"       element={<EventosPage />} />
            <Route path="/festejo"       element={<FestejoPage />} />
            <Route path="/galeria"       element={<GaleriaPage />} />
          </Route>

          <Route path="/admin/login" element={<LoginPage />} />

          <Route
            path="/admin"
            element={
              <RotaProtegida>
                <LayoutAdmin />
              </RotaProtegida>
            }
          >
            <Route index                element={<DashboardPage />} />
            <Route path="documentos"    element={<AdminDocumentosPage />} />
            <Route path="galeria"       element={<AdminGaleriaPage />} />
            <Route path="eventos"       element={<AdminEventosPage />} />
            <Route path="festejo"       element={<AdminFestejoPage />} />
            <Route path="configuracoes" element={<AdminConfiguracoesPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              fontFamily: 'var(--fonte-corpo)',
              fontSize: '0.9rem',
              borderRadius: '10px',
            },
            success: { iconTheme: { primary: '#16a34a', secondary: '#fff' } },
            error:   { iconTheme: { primary: '#dc2626', secondary: '#fff' } },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}